import { render, staticRenderFns } from "./billArticle.vue?vue&type=template&id=f2cb44c8&"
import script from "./billArticle.vue?vue&type=script&lang=js&"
export * from "./billArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports